import { Pipe, PipeTransform } from '@angular/core';
import { normalizeQuery } from './search-utils';
import { Trainer } from '../../_services';

@Pipe({ name: 'filterByNameOrLabel' })
export class TrainersLabelPipe implements PipeTransform {
    noSearchFilter(trainers: any[], active: boolean): any[] {
        return trainers.filter((trainer) => {
            if (active) {
                return trainer.active;
            }
            return true;
        });
    }

    transform(
        trainers: any[],
        search: string,
        active: boolean,
        filterMetadata?: any,
        filterLabel?: string
    ): any[] {
        let filteredTrainers = [];
        search = search.trim();
        if (trainers === undefined) {
            return;
        } else if (search === '') {
            filteredTrainers = this.noSearchFilter(trainers, active);
        } else if (filterLabel === 'name') {
            trainers.map((trainer: Trainer) => {
                if (!trainer.active && active) {
                    return;
                }
                if (
                    normalizeQuery(
                        `${trainer.firstName} ${trainer.lastName}`
                    ).includes(normalizeQuery(search))
                ) {
                    filteredTrainers.push(trainer);
                }
            });
        } else {
            trainers.map((trainer: Trainer) => {
                if (!trainer.active && active) {
                    return;
                }
                trainer.trainerSkills.map((skill) => {
                    if (
                        search !== '' &&
                        skill.trainingName
                            .toUpperCase()
                            .includes(search.toUpperCase()) &&
                        ((filterLabel === 'can' &&
                            skill.can &&
                            !skill.refuse) ||
                            (filterLabel === 'given' &&
                                skill.nbGiven > 0 &&
                                !skill.refuse) ||
                            (filterLabel === 'wished' &&
                                skill.wished &&
                                !skill.refuse) ||
                            (filterLabel === 'followed' &&
                                skill.followed &&
                                !skill.refuse) ||
                            (filterLabel === 'refuse' &&
                                skill.refuse &&
                                !skill.refuse)) &&
                        filteredTrainers.indexOf(trainer) === -1
                    ) {
                        filteredTrainers.push(trainer);
                    }
                });
            });
        }

        switch (filterLabel) {
            case 'name': {
                filterMetadata.countName = filteredTrainers.length;
                break;
            }
            case 'can': {
                filterMetadata.countCan = filteredTrainers.length;
                break;
            }
            case 'given': {
                filterMetadata.countGiven = filteredTrainers.length;
                break;
            }
            case 'wished': {
                filterMetadata.countWished = filteredTrainers.length;
                break;
            }
            case 'followed': {
                filterMetadata.countFollowed = filteredTrainers.length;
                break;
            }
            case 'refuse': {
                filterMetadata.countRefuse = filteredTrainers.length;
                break;
            }
            default: {
                break;
            }
        }
        return filteredTrainers;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainers-label.pipe.ts